import './header';
import './footer';
import './newsletter';

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
    const dataSrc = elemento.getAttribute('data-src');
    if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
    }
});

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;
    
    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function(tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
      tabAccordion.addEventListener('click', function () {
          tabAccordions.forEach(function (tab) {
              tab.classList.remove('active');
          });

          contentAccordions.forEach(function (content) {
              content.classList.remove('active');
          });
          
          tabAccordion.classList.add('active');
          contentAccordions[index].classList.add('active');
      });
  });
});

// GET WIDGETS LOADED ON SCROLL -- Esse Script ativa os Widgets dando mouseenter conforme o scroll na pagina. Para produtos com variaçao
(function($) {
  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };
    
})(jQuery);

function loadWidgets (event) {

  $(".product-item:not(.widget-loaded)").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("widget-loaded");
      $(el).children().trigger("mouseenter");
    } else {
      //el.removeClass("visible");
    }
  });
}

$(window).scroll(loadWidgets);
setTimeout(loadWidgets, 0); 

// -----------------------------------------------------------------------------------------------------------------------
// ------------------------------------------------ Quantity product item ------------------------------------------------
// -----------------------------------------------------------------------------------------------------------------------

$("body").on("click", ".product-item__qtd__minus", function(event) {
  var $this = $(this);
  var clt = $this.closest(".product-item__qtd");
  var qt_el = clt.find(".product_qtd__product_detail_list");
  var qtd = parseInt(qt_el.val());
  if (isNaN(qtd)){
      qtd = 1;
  }

  if (qtd > 1) qtd--;
  qt_el.val(qtd);
});

$("body").on("click", ".product-item__qtd__plus", function(event) {
  var $this = $(this);
  var clt = $this.closest(".product-item__qtd");
  var qt_el = clt.find(".product_qtd__product_detail_list");
  var qtd = parseInt(qt_el.val());
  if (isNaN(qtd)){
      qtd = 1;
  }else{
      qtd++;
  }
  qt_el.val(qtd);
});